<!-- 商品卡片组件（完全体） -->
<template>
  <div
    class="product-item"
    :key="product.shop_sku"
    v-exposure="{
      callback: () => {
        handleProductExposure({ product: product, index: clickIndex });
      },
      ts: ts,
    }"
  >
    <a
      :href="product.id ? `/goods-detail/${product.id}` : ''"
      class="top-box"
      :aria-label="product.name"
      @click.prevent="handleProductClick({ product: product, index: clickIndex })"
    >
      <div
        :class="[
          'go',
          cardType === CARD_TYPE.CARD && 'isCardType',
          product.is_glass !== 1 && 'isNotGlass',
        ]"
        :style="imageRatio ? { 'aspect-ratio': imageRatio } : {}"
      >
        <div v-if="showTag" :class="['tag-box', cardType === CARD_TYPE.CARD && 'tag-box-card']">
          <ProductCardTag :detail="product" :isShowHalfLabel="isShowHalfLabel" />
        </div>
        <div
          v-if="!inErrorPage && showWishButton && heartChange && !isEditMode && product.id"
          :class="['heartbox', cardType === CARD_TYPE.CARD && 'heartbox-card']"
        >
          <client-only>
            <ProductWishButton
              class="wish"
              :productId="product.id"
              loginSituationNew="商品收藏"
              @success="wishSuccess(product, $event)"
              @cancel="wishCancel(product, $event)"
            />
          </client-only>
        </div>
        <div
          v-if="computedShowNonRxTag"
          :class="['non-rx-tag', cardType === CARD_TYPE.CARD && 'non-rx-tag-card']"
        >
          Non-Rx
        </div>
        <div
          v-if="computedShowSunGlassesLogo"
          :class="['sunglasses-logo', cardType === CARD_TYPE.CARD && 'sunglasses-logo-card']"
        >
          <img :src="sunglassLogo" alt="vooglam-sunglasses" /><span>Multiple Tints</span>
        </div>
        <div v-if="isEditMode" class="edit-mode-heartbox" @click.prevent.stop="">
          <slot name="action"></slot>
        </div>
        <ProductImage
          :product="product"
          :showMaterialImg="showMaterialImg"
          :cardType="cardType"
          :imageRatio="imageRatio"
          :imageLoadMode="imageLoadMode"
          :soldOutText="soldOutText"
          :imgAlt="imgAlt"
        />
        <slot name="addToCart"></slot>
      </div>
    </a>
    <!-- 商品列表页样式，底部信息 -->
    <div
      v-if="cardType === CARD_TYPE.GOODS_LIST"
      class="product-info"
      @click="handleProductClick({ product: product, index: clickIndex, isBottom: true })"
    >
      <div :class="['info', !computedShowChangeColor ? 'info-with-try-on' : '']">
        <div class="short-name">
          {{ product.short_name }}
        </div>
        <ProductPrice :product="product" :showUnderlinePrice="showUnderlinePrice" />
        <!-- 若不展示色块，试戴按钮和名称价格在同一行 -->
        <div
          v-if="computedShowTryOnBtn && !computedShowChangeColor"
          class="try-on-btn try-on-btn-at-info"
          @click.stop="handleTryOnShow"
        >
          Try-On
        </div>
      </div>
      <div v-if="computedShowLongName" class="long-name">
        {{ processLongName(product?.short_name || '', product?.name || '') }}
      </div>
      <!-- 如果展示色块，则色块和试戴按钮在同一行 -->
      <div class="info-btm" v-if="computedShowChangeColor">
        <div class="relate-color">
          <client-only>
            <ChangeColor
              :rels="correlation"
              :currentItem="product"
              :productData="productData"
              :showOnlyOneColor="showOnlyOneColor"
              ref="changeColorRef"
              @relChange="relChange"
            />
          </client-only>
        </div>
        <div v-if="computedShowTryOnBtn" class="try-on-btn" @click.stop="handleTryOnShow">
          Try-On
        </div>
      </div>
    </div>
    <!-- 卡片样式，底部信息 -->
    <div
      v-else-if="cardType === CARD_TYPE.CARD"
      :class="['card-product-info', product.is_glass !== 1 && 'isNotGlass']"
      @click="handleProductClick({ product: product, index: clickIndex, isBottom: true })"
    >
      <div
        class="card-product-info-content"
        :class="[showPriceLeftChangeColor && 'has-outer-related-correlation']"
      >
        <span v-if="!showPriceLeftChangeColor" class="card-product-info-content-short-name">{{
          product.short_name
        }}</span>
        <div
          v-if="showPriceLeftChangeColor && relatedCorrelation && relatedCorrelation.length > 0"
          class="card-product-info-center"
          :class="[showPriceLeftChangeColor && 'has-outer-related-correlation']"
        >
          <ChangeColor
            :rels="relatedCorrelation || correlation"
            :currentItem="product"
            :productData="productData"
            :showOnlyOneColor="showOnlyOneColor"
            ref="changeColorRef"
            @relChange="relChange"
          />
        </div>
        <ProductPrice :showUnderlinePrice="showUnderlinePrice" :product="product" />
      </div>
      <p v-if="computedShowLongName" class="long-name">
        {{ processLongName(product?.short_name || '', product?.name || '') }}
      </p>
      <div
        v-if="computedShowChangeColor && !showPriceLeftChangeColor"
        class="card-product-info-btm"
      >
        <client-only>
          <ChangeColor
            :rels="correlation"
            :currentItem="product"
            :productData="productData"
            :showOnlyOneColor="showOnlyOneColor"
            ref="changeColorRef"
            @relChange="relChange"
          />
        </client-only>
      </div>
      <div v-else class="card-product-info-no-change-color"></div>
    </div>
    <!-- 小尺寸样式，名称和try on在一行，价格单独一行，没有关联色块 -->
    <div
      v-else-if="cardType === CARD_TYPE.SMALL_SIZE"
      class="small-size-product-info"
      @click="handleProductClick({ product: product, index: clickIndex, isBottom: true })"
    >
      <div class="small-size-product-info-content">
        <span class="small-size-product-info-content-short-name">{{ product.short_name }}</span>
        <div v-if="computedShowTryOnBtn" class="try-on-btn" @click.stop="handleTryOnShow">
          Try-On
        </div>
      </div>
      <ProductPrice :product="product" :showUnderlinePrice="showUnderlinePrice" />
    </div>
    <div
      v-if="showIntroBtn"
      class="product-intro-btn"
      :style="{
        background: displayedShowIntroInfo.btn_bg_color,
        color: displayedShowIntroInfo.btn_color,
      }"
      @click="handleProductClick({ product: product, index: clickIndex, isBottom: true })"
    >
      {{ displayedShowIntroInfo.btn_text }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { getProductCardSensorsTrackParams } from '@/composables/useProductCard';
import { processLongName } from '@/assets/js/utils';
import { useStore } from '@/store';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import type { CardTypeValue } from './constants';
import { CARD_TYPE } from './constants';
import ProductImage from './modules/ProductImage.vue';
import ProductPrice from './modules/ProductPrice.vue';
import ProductCardTag from './modules/ProductCardTag.vue';
import { genPrice } from '@/assets/js/currency-price';
import type { IProductClickEvent, IProductExposureEvent, ImageLoadMode, IWishEvent } from './types';
import { defineAsyncComponent, type Ref } from 'vue';
import type { ProductsListItem } from '@/api/types/product';
import sunglassLogo from '@/assets/images/goods-detail/sunglasses_logo.svg';

const ChangeColor = defineAsyncComponent({
  loader: () => import('./modules/ChangeColor.vue'),
  delay: 200,
  timeout: 10000,
});

const ProductWishButton = defineAsyncComponent({
  loader: () => import('../product-wish-button/ProductWishButton.vue'),
  delay: 200,
  timeout: 10000,
});

interface Props {
  productData: ProductsListItem;
  clickIndex?: number;
  mktName?: string;
  uuid?: string;
  ts?: number;
  isAcc?: boolean;
  cardType?: CardTypeValue;
  showOnlyOneColor?: boolean;
  isShowHalfLabel?: boolean;
  isEditMode?: boolean;
  imageLoadMode?: ImageLoadMode;
  showTag?: boolean;
  showLongName?: boolean;
  showUnderlinePrice?: boolean;
  showWishButton?: boolean;
  showTryOnBtn?: boolean;
  showChangeColor?: boolean;
  showMaterialImg?: boolean;
  showNonRxTag?: boolean;
  forbidJump?: boolean;
  imageRatio?: string;
  soldOutText?: string;
  inErrorPage?: boolean;
  showPriceLeftChangeColor?: boolean;
  showIntroBtn?: boolean;
  showIntroInfo?: {
    btn_bg_color: string;
    btn_color: string;
    btn_text: string;
  };
  /** 传入时，intro 按钮文案按卡片当前展示商品（含换色后）的 is_glass / is_sunglasses 从本对象取 */
  introBtnTypeText?: {
    eye_glasses?: string;
    sun_glasses?: string;
  };
  relatedCorrelation?: ProductsListItem[];
  imgAlt?: string;
  showSunGlassesLogo?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  clickIndex: 0,
  mktName: '',
  uuid: '',
  ts: 1,
  isAcc: false,
  cardType: CARD_TYPE.GOODS_LIST,
  showOnlyOneColor: false,
  isShowHalfLabel: false,
  isEditMode: false,
  imageLoadMode: 'lazy',
  showTag: true,
  showLongName: true,
  showUnderlinePrice: true,
  showWishButton: true,
  showTryOnBtn: true,
  showChangeColor: true,
  showMaterialImg: false,
  showNonRxTag: true,
  forbidJump: false,
  imageRatio: '',
  soldOutText: 'Sold Out',
  inErrorPage: false,
  showPriceLeftChangeColor: false,
  showIntroBtn: false,
  showIntroInfo: () => ({
    btn_bg_color: '',
    btn_color: '',
    btn_text: '',
  }),
  introBtnTypeText: () => ({}),
  relatedCorrelation: () => [],
  imgAlt: '',
  showSunGlassesLogo: true, // 是否展示太阳镜logo
});

interface Emits {
  (e: 'wishSuccess', event: IWishEvent): void;
  (e: 'wishCancel', event: IWishEvent): void;
  (e: 'exposure', event: IProductExposureEvent): void;
  (e: 'itemClick', event: IProductClickEvent): void;
  (e: 'tryOnShow', product: ProductsListItem): void;
  (e: 'bottomAreaClick', event: IProductClickEvent): void;
}

const emit = defineEmits<Emits>();
const store = useStore();
const route = useRoute();

// 暴露给模板使用
const { userInfo } = storeToRefs(store);

const product: Ref<ProductsListItem> = ref({} as ProductsListItem);
const correlation: Ref<ProductsListItem[]> = ref([]); // 当前商品的关联品
const heartChange = ref<boolean>(true); // 关联品切换的时候隐藏heart
const relChangeArr = ref<string[]>([]);
// 定义 ChangeColor 组件的 ref 类型
interface ChangeColorRef {
  getColorNum(): number;
}
const changeColorRef = ref<ChangeColorRef | null>(null);

const computedShowTryOnBtn = computed<boolean>(() => {
  if (props.isAcc) return false;
  return props.showTryOnBtn && product.value.is_glass == 1 && !!product.value.tryon_image_url;
});

// 商品网站分类=太阳镜，且不可配镜时，右下角显示该文案 Non-Rx
const computedShowNonRxTag = computed<boolean>(() => {
  return (
    props.showNonRxTag &&
    product.value.is_glass == 1 &&
    product.value.is_sunglasses == 1 &&
    product.value.product_lens === 2
  );
});

// 商品网站分类=太阳镜，且可配镜时，显示太阳镜标识
const computedShowSunGlassesLogo = computed<boolean>(() => {
  return (
    props.showSunGlassesLogo &&
    product.value.is_glass == 1 &&
    product.value.is_sunglasses == 1 &&
    product.value.product_lens == 1
  );
});

const computedShowLongName = computed<boolean>(() => {
  return props.showLongName && product.value.is_glass === 1;
});

const computedShowChangeColor = computed<boolean>(() => {
  return props.showChangeColor && product.value.is_glass === 1 && correlation.value.length > 0;
});

const displayedShowIntroInfo = computed(() => {
  const base = props.showIntroInfo || {
    btn_bg_color: '',
    btn_color: '',
    btn_text: '',
  };
  const typeText = props.introBtnTypeText;
  if (!typeText || (typeText.eye_glasses == null && typeText.sun_glasses == null)) {
    return base;
  }
  const p = product.value;
  const fallback = base.btn_text ?? '';
  let btnText = fallback;
  if (p.is_glass == 1 && p.is_sunglasses != 1) {
    btnText = typeText.eye_glasses ?? fallback;
  } else if (p.is_glass == 1 && p.is_sunglasses == 1) {
    btnText = typeText.sun_glasses ?? fallback;
  }
  return { ...base, btn_text: btnText };
});

type CorrelationItem = Omit<ProductsListItem, 'correlation'>;

watch(
  () => props.productData,
  (val) => {
    if (!val) return;
    const { correlation: correlationData = [] } = val as ProductsListItem & {
      correlation?: ProductsListItem[];
    };

    if (
      Array.isArray(correlationData) &&
      correlationData.length &&
      !props.isAcc &&
      props.showChangeColor &&
      val.is_glass === 1
    ) {
      const newCorrelation: ProductsListItem[] = correlationData.map((item: CorrelationItem) => {
        const newItem: ProductsListItem = {
          ...(item as unknown as ProductsListItem),
          spu_review_stars: val.spu_review_stars,
          spu_review_count: val.spu_review_count,
          display_color_num: correlationData.length,
          fine_ranking_type: val.fine_ranking_type,
          recall_group_type: val.recall_group_type,
        };
        return newItem;
      });
      product.value = newCorrelation[0] || val;
      if (val.has_glasses) {
        product.value.has_glasses = val.has_glasses;
      }
      correlation.value = newCorrelation || [];
      if (props.showOnlyOneColor) {
        correlation.value = [newCorrelation[0]];
      }
    } else {
      product.value = val;
      correlation.value = [];
    }
  },
  { immediate: true },
);

watch(
  () => props.ts,
  () => {
    relChangeArr.value = [];
  },
  { immediate: true },
);

const handleTryOnShow = (): void => {
  emit('tryOnShow', { ...product.value, sensorData: sensorsTrackParams.value });
};

const wishSuccess = (item: ProductsListItem, eventId: string): void => {
  SDCollectBtnClick({
    collect_type: '收藏',
    virtually_no: `${userInfo.value?.uuid || ''}${Date.now()}`,
    business_sku: item.business_sku,
    shop_sku: item.shop_sku,
    product_sku: item.sku,
    product_id: `${item.id || ''}`,
    product_name: item.short_name,
    event_id: eventId,
  });
  if (product.value.wish_num !== undefined) {
    product.value.wish_num++;
  }
  const productWithSensors: ProductsListItem = {
    ...item,
    sensorData: sensorsTrackParams.value,
  };
  emit('wishSuccess', {
    product: productWithSensors,
    index: props.clickIndex,
  });
};

const wishCancel = (item: ProductsListItem, eventId: string): void => {
  SDCollectBtnClick({
    collect_type: '取消收藏',
    virtually_no: `${userInfo.value?.uuid || ''}${Date.now()}`,
    business_sku: item.business_sku,
    shop_sku: item.shop_sku,
    product_sku: item.sku,
    product_id: `${item.id || ''}`,
    product_name: item.short_name,
    event_id: eventId,
  });
  if (product.value.wish_num !== undefined) {
    product.value.wish_num--;
  }
  setTimeout(() => {
    const productWithSensors: ProductsListItem = {
      ...item,
      sensorData: sensorsTrackParams.value,
    };
    emit('wishCancel', {
      product: productWithSensors,
      index: props.clickIndex,
    });
  }, 1000);
};
const relChange = (item: ProductsListItem) => {
  product.value = item;
  heartChange.value = false;
  nextTick(() => {
    heartChange.value = true;
  });
  if (props.productData.shop_sku) {
    relChangeArr.value.push(props.productData.shop_sku);
  }
  if (item.shop_sku && !relChangeArr.value.includes(item.shop_sku)) {
    relChangeArr.value.push(item.shop_sku);
  }
};

interface CollectBtnParams {
  collect_type: string;
  virtually_no: string;
  business_sku?: string;
  shop_sku?: string;
  product_sku?: string;
  product_id: string;
  product_name?: string;
}

/**
 * @TrackType sensorsdata
 * @EventType CollectBtn_Click
 * @EventDesc 收藏按钮点击
 * @EventParams {
 *  page_name: 页面名称,
 *  url_path: 页面路径,
 *  collect_type: 收藏类型,
 *  virtually_no: 虚拟编号,
 *  shop_sku: 站点商品sku,
 *  product_sku: 商品sku,
 *  product_id: 商品ID,
 *  product_name: 商品名称,
 *  is_glass_type: 当前列表类目是否是镜框类列表, true：镜框  false：非镜框 只在列表页加该字段,
 * }
 * @Tapd 1009440
 */
const SDCollectBtnClick = (params: CollectBtnParams): void => {
  try {
    const sdEventName = 'CollectBtn_Click';
    const sdEventParams = {
      page_name: route.meta.cnName,
      url_path: window.location.href,
      ...params,
      is_glass_type: true,
    };
    window.voo_sensors?.sensorsTrack(sdEventName, sdEventParams);
  } catch (e) {
    console.log(e);
  }
};

const sensorsTrackParams = computed(() => {
  return getProductCardSensorsTrackParams(
    product.value,
    props.clickIndex,
    store.currency,
    genPrice,
    {
      display_color_num: changeColorRef.value?.getColorNum() || null,
      showMaterialImg: props.showMaterialImg,
      isHalfPrice: props.isShowHalfLabel,
      showNonRxTag: computedShowNonRxTag.value,
      mktName: props.mktName,
    },
  );
});

const router = useRouter();
/**
 * 处理商品点击事件,发送埋点数据
 */
const handleProductClick = ({
  product: productItem,
  index: clickIndex,
  isBottom = false,
}: IProductClickEvent): void => {
  const productWithSensors: ProductsListItem = {
    ...productItem,
    sensorData: sensorsTrackParams.value,
  };
  if (isBottom && props.isEditMode) {
    // 只有在编辑模式下，点击底部区域的事件才会抛出
    emit('bottomAreaClick', {
      product: productWithSensors,
      index: clickIndex,
    });
    return;
  }
  emit('itemClick', {
    product: productWithSensors,
    index: clickIndex,
  });
  if (props.forbidJump || !productItem.id) return;
  router.push(`/goods-detail/${productItem.id}`);
};

const exposedArr = ref<string[]>([]);
watch(
  () => props.ts,
  () => {
    exposedArr.value = [];
  },
  { immediate: true },
);
/**
 * 处理商品曝光事件,发送埋点数据
 */
const handleProductExposure = ({
  product: productItem,
  index: clickIndex,
}: IProductExposureEvent): void => {
  const productWithSensors: ProductsListItem = {
    ...productItem,
    sensorData: sensorsTrackParams.value,
  };
  if (productItem.shop_sku && exposedArr.value.includes(productItem.shop_sku)) return;
  if (productItem.shop_sku) {
    exposedArr.value.push(productItem.shop_sku);
  }
  emit('exposure', {
    product: productWithSensors,
    index: clickIndex,
  });
};
</script>

<style lang="scss" scoped>
.product-item {
  position: relative;
  color: #080506;
  transition: all 0.3s;
  box-sizing: border-box;
  .go {
    position: relative;
    margin: 0 auto;
    width: 100%;
    aspect-ratio: 1;
    background-color: #f2f2f2;
    &.isCardType {
      aspect-ratio: 432/358;
      box-sizing: border-box;
      &.isNotGlass {
        padding-top: 0;
      }
    }

    @include flex(center, center);
    .tag-box {
      position: absolute;
      z-index: 3;
      left: 20px;
      top: 20px;
      &.tag-box-card {
        left: 24px;
        top: 24px;
      }
    }
    a {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  // 当 a 标签 hover 时，触发 ProductImage 内部的 hover 效果
  .top-box:hover {
    :deep(.img-wrap.has-hover-image) img.good-img {
      opacity: 0;
    }
    :deep(.img-wrap.has-hover-image) img.good-img2 {
      opacity: 1;
    }
    :deep(.img-wrap.has-hover-image .sold-out-img-inner) img.good-img2 {
      opacity: 0.4;
    }
  }
  .product-info {
    cursor: pointer;
    position: relative;
    padding: 16px 6px 0;
    background-color: white;
    .info {
      @include flex(normal, center);

      overflow: hidden;
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      gap: 0 10px;
      &.info-with-try-on {
        height: 28px;
        line-height: 28px;
        .try-on-btn {
          flex: none;
        }
      }
      .short-name {
        @include ellipsis(1);

        max-width: 100%;
        font-family: $f-pb;
        color: #080506;
      }
      :deep(.price) {
        @include flex(normal, center, $wrap: wrap);

        height: 28px;
        line-height: 28px;
        gap: 0 6px;
        flex: 1;
        span {
          white-space: nowrap;
        }
      }
    }
    .long-name {
      @include ellipsis(1);

      margin-top: 4px;
      width: 100%;
      line-height: 20px;
      font-size: 14px;
      font-family: $f-lr;
      color: #908b7f;
    }
    .info-btm {
      @include flex(space-between, center);

      margin-top: 16px;
      .relate-color {
        @include flex(center, center);
      }
    }
  }
  .heartbox {
    @include flex(center, center);

    position: absolute;
    z-index: 3;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    &.heartbox-card {
      right: 24px;
      top: 24px;
    }
  }
  .non-rx-tag {
    position: absolute;
    z-index: 3;
    right: 20px;
    bottom: 20px;
    line-height: 22px;
    font-size: 14px;
    font-family: $f-pr;
    color: #6f1606;
    &.non-rx-tag-card {
      right: 24px;
      bottom: 20px;
    }
  }
  .sunglasses-logo {
    @include flex(normal, center);

    position: absolute;
    z-index: 3;
    right: 20px;
    bottom: 20px;
    span {
      margin-left: 4px;
      line-height: 22px;
      font-size: 14px;
      font-family: $f-pr;
      color: #626668;
    }
    img {
      width: 18px;
      height: 18px;
    }
    &.sunglasses-logo-card {
      right: 24px;
      bottom: 20px;
    }
  }
  .edit-mode-heartbox {
    position: absolute;
    z-index: 3;
    right: 20px;
    top: 20px;
    :deep(.el-checkbox) {
      width: 22px;
      height: 22px;
      font-size: 22px;
      .el-checkbox__inner {
        transform: scale(1);
        border-radius: 2px !important;
      }
    }
  }
  .card-product-info {
    padding: 0 24px;
    cursor: pointer;
    background-color: #f2f2f2;
    &.isNotGlass {
      .card-product-info-content {
        border: none;
      }
    }
    .card-product-info-content {
      overflow: hidden;
      padding-top: 21px;
      height: 24px;
      border-top: 1px solid #e3e1de;
      box-sizing: content-box;
      &.has-outer-related-correlation {
        align-items: center;
      }

      @include flex(space-between, baseline);
      .card-product-info-content-short-name {
        @include ellipsis(1);

        line-height: 24px;
        font-size: 16px;
        font-family: $f-pb;
      }
      :deep(.price) {
        @include flex(flex-end, center, $wrap: wrap);

        flex: 1;
        gap: 0 6px;
        font-size: 16px;
        span {
          white-space: nowrap;
        }
      }
    }
    .long-name {
      @include ellipsis(1);

      margin-top: 6px;
      width: 100%;
      line-height: 20px;
      font-size: 14px;
      font-family: $f-lr;
      color: #908b7f;
    }
    .card-product-info-center {
      padding-top: 16px;
      padding-bottom: 30px;
      &.has-outer-related-correlation {
        padding: 0;
      }
    }
    .card-product-info-btm {
      padding-top: 16px;
      padding-bottom: 30px;
    }
    .card-product-info-no-change-color {
      padding-bottom: 30px;
    }
  }
  .product-intro-btn {
    @include flex(center, center);

    width: 100%;
    height: 50px;
    font-size: 20px;
    font-family: $f-pr;
    cursor: pointer;
  }
  .small-size-product-info {
    padding: 16px 6px 0;
    background-color: #ffffff;
    cursor: pointer;
    .small-size-product-info-content {
      @include flex(space-between, center);

      padding-bottom: 6px;
      .small-size-product-info-content-short-name {
        @include ellipsis(1);

        line-height: 24px;
        font-size: 16px;
        font-family: $f-pb;
        flex: 1;
      }
    }
    :deep(.price) {
      @include flex(normal, center, $wrap: wrap);

      overflow: hidden;
      height: 24px;
      line-height: 24px;
      gap: 0 6px;
      span {
        font-size: 16px;
      }
    }
  }
}
.try-on-btn {
  @include flex(center, center);

  padding: 0 10px;
  height: 26px;
  border: 1px solid rgba(39, 23, 23, 0.4);
  border-radius: 13px;
  font-size: 14px;
  background: #ffffff;
  box-sizing: border-box;
  cursor: pointer;
  .try-on-btn-at-info {
    flex: none;
  }
}
</style>
